module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEESURBVHgBtVSBDcIgEPy6gIzABjICI7hB2UA30A0cod2EOoFuUJ1AN6hHfBKiLQW0l1xo4f76/fxDtBCq2OEwDAqLo+StK9hVVfWkGawmDDVo8diwsUcN9jhrQEk5QMAJvDjziOYI9vxHyaZtolYlmUNgnJAywCVz5iIm6rPr9o5rXWko8mVLBZiK9V2hwTMVAK3XYVGf5fDGErxROVxfr8eMf8XXwHhjN1FpPTkOhZLcp4w3VAAepC4msLFpm4kzMYHO7WVoD0ltGtwBMkG7y0oEwj0HmLEgPxBMyXvJl5HkUX0EJjZ4N4FWcCI15YBvMc2riCSSb56YgDff0r/B5oKWxAtzXR5kUMVcOQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/seauch.png
// module id = Jm4u
// module chunks = 1